import { useCallback, useEffect, useRef, useState } from 'react';

declare global {
    var $: any
}

export function useBootstrapTooltip() {
    const [element, setElement] = useState<HTMLElement>();

    useEffect(() => {
        if (element && element.title) {
            $(element).tooltip(true);

            const clck = (e) => {
                $(e.target).tooltip('hide');
            };

            $(element).on('click', clck);

            return () => {
                $(element).tooltip('hide');
                $(element).off('click', clck);
            };
        }
    }, [element]);

    return useCallback((element: HTMLElement) => {
        setElement(element);
    }, []);
}
